import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGraphUser } from "../../types/user";

//Defining our initialState's type
type initialStateType = {
  users: IGraphUser[];
};

const initialState: initialStateType = {
  users: [],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    // Reducer to set users
    setUsers: (state, action: PayloadAction<IGraphUser[]>) => {
      state.users = action.payload;
    },
    setUserPhoto: (
      state,
      action: PayloadAction<{ userId: string; photoUrl: string | null }>
    ) => {
      const { userId, photoUrl } = action.payload;
      const user = state.users.find((user) => user.id === userId);
      if (user) {
        user.photoUrl = photoUrl; // Assuming IGraphUser has a photoUrl property
      }
    },
  },
});

export const getUser = (state: initialStateType, userId: string) => {
  return state.users.find((user) => user.id === userId);
};

// To able to use reducers we need to export them.
export const { setUsers, setUserPhoto } = usersSlice.actions;

//Selector to access kpiList state.
// export const selectUsers = (state: RootState) => state.users;

export default usersSlice.reducer;
